import { render, staticRenderFns } from "./SelectOwner.vue?vue&type=template&id=7286b8a5&"
import script from "./SelectOwner.vue?vue&type=script&lang=ts&"
export * from "./SelectOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports